// Mirrors Studio Playground frontend/src/utils/reflectEditor.js.

const WORD_PATTERN = /[\p{L}\p{N}]+(?:['’][\p{L}\p{N}]+)*/gu;
const VOWEL_GROUP = /[aeiouy]+/g;
const RHYME_COLORS = ['#00D4AA', '#FF8A00', '#FF2D78', '#FFD700', '#B44DFF', '#4DA6FF'];

export function countWordSyllables(word = '') {
  const clean = String(word).toLocaleLowerCase().replace(/[^a-z]/g, '');
  if (!clean) return 0;
  let count = (clean.match(VOWEL_GROUP) || []).length;
  const keepsFinalE = /[^aeiouy]le$/.test(clean) || /(ee|ye)$/.test(clean);
  if (count > 1 && clean.endsWith('e') && !keepsFinalE) count -= 1;
  return Math.max(1, count);
}

export function countSyllables(text = '') {
  return (String(text).match(WORD_PATTERN) || [])
    .reduce((total, word) => total + countWordSyllables(word), 0);
}

export function pocketMeter(text = '') {
  const count = countSyllables(text);
  return { count, filled: Math.min(16, count), crowded: count > 16 };
}

export function lastWord(text = '') {
  const words = String(text).match(WORD_PATTERN) || [];
  return words.length ? words[words.length - 1].toLocaleLowerCase() : '';
}

export function rhymeFamilyColor(word = '') {
  const normalized = word.toLowerCase().replace(/[^a-z]/g, '');
  if (!normalized) return 'var(--text-dim)';
  const tail = normalized.match(/[aeiouy]+[^aeiouy]*$/)?.[0] || normalized;
  const index = [...tail].reduce((sum, char) => sum + char.charCodeAt(0), 0) % RHYME_COLORS.length;
  return RHYME_COLORS[index];
}

export function lyricWords(lyrics) {
  const words = new Set();
  lyrics.sections.forEach((section) => section.lines.forEach((line) => {
    (line.text.toLowerCase().match(/[\p{L}\p{N}']+/gu) || []).forEach((word) => words.add(word));
  }));
  return [...words].slice(0, 400);
}

export function rhymeRequestWords(lyrics, kiosk) {
  return kiosk ? [] : lyricWords(lyrics);
}

export function swapLastWord(text, replacement) {
  const matches = [...String(text).matchAll(WORD_PATTERN)];
  const cleanReplacement = lastWord(replacement);
  if (!matches.length || !cleanReplacement) return String(text);
  const match = matches[matches.length - 1];
  return `${text.slice(0, match.index)}${cleanReplacement}${text.slice(match.index + match[0].length)}`;
}
